import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-common-save-confirm-dialog',
    templateUrl: './common-save-confirm-dialog.component.html',
    styleUrls: ['./common-save-confirm-dialog.component.scss'],
    standalone: false
})

export class CommonSaveConfirmDialogComponent implements OnInit {
  isMove: boolean;
  isError: boolean;

  message: string = 'commonSaveConfirmDialog.message';
  isMovingMessage: string = 'commonSaveConfirmDialog.isMovingMessage';
  isClosingMessage: string = 'commonSaveConfirmDialog.isClosingMessage';
  customMessage: string = '';

  notSaveBtnLabel: string = 'commonSaveConfirmDialog.notSave';
  cancelBtnLabel: string = 'commonSaveConfirmDialog.cancel';
  saveBtnLabel: string = 'commonSaveConfirmDialog.save';

  constructor(
    public dialogRef: MatDialogRef<CommonSaveConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }
  ngOnInit() {
    this.isMove = this.data.isMove;
    this.isError = this.data.isError;
    if (this.data.hasOwnProperty('message')) {
      this.message = this.data.message;
    }
    if (this.data.hasOwnProperty('customMessage')) {
      this.customMessage = this.data.customMessage;
    }
    if (this.data.hasOwnProperty('notSaveBtnLabel')) {
      this.notSaveBtnLabel = this.data.notSaveBtnLabel;
    }
  }
}
